/* eslint-disable camelcase */
import { get } from 'lodash';
import { takeEvery } from 'redux-saga';
import { call, select, put } from 'redux-saga/effects';

import {
    FIRE_UTAG,
    HANDLE_UTAG_EVENT,
    POLL_UTAG,
    fireUtag,
    handleUtagEvent,
    pollUtag
} from '../actions/initialActions.js';

import { delay } from '../utils';
import {
    UTAG_POLL_TIME,
    isCheckout,
    utagIsLoaded,
    utagLink,
    utagView
} from '../utils/analyticsUtils';
import { error, info, warn } from '../utils/logger';

/**
 * utag loads async so we need to poll utag to make sure it's defined before executing
 * polling will stop and throw an error is window.utag is not defined after 2 seconds
 */
export function* handleUtagEventSaga() {
    yield* takeEvery(HANDLE_UTAG_EVENT, utagEventSaga);
}

export function* utagEventSaga({ payload }) {
    const state = yield select();
    const endTime = payload.endTime || Date.now() + UTAG_POLL_TIME;
    const enableTealium = !isCheckout() && get(state, 'core.thirdParty.tealium', true);
    const eventCategory = get(payload, 'data.event_category');
    const pageTypeKey = get(state, 'core.constants.pageTypeKey', 'PAGE_TYPE');
    const tabTypeKey = get(state, 'core.constants.tabTypeKey', 'TAB_TYPE');

    if (eventCategory === pageTypeKey && get(state, 'core.pageType')) {
        payload.data.event_category = state.core.pageType;
    } else if (eventCategory === tabTypeKey) {
        payload.data.event_category = _.get(state, 'mto.selectedTabName');
    }

    if (enableTealium) {
        if (utagIsLoaded()) {
            yield put(fireUtag(payload));
        } else {
            yield put(pollUtag(endTime, payload));
        }
    }
}

/**
 * Fires a utag event based on payload.event and payload.data
 * This should be used for situations where we need to fire a utag event after an API response
 */
export function* fireUtagSaga() {
    yield* takeEvery(FIRE_UTAG, handleFireUtagSaga);
}

export function* handleFireUtagSaga({ payload }) {
    switch (payload.event) {
        case 'link':
            utagLink(payload.data);
            info('utag.link fired', payload.data);
            break;
        case 'view':
            utagView(payload.data);
            info('utag.view fired', payload.data);
            break;
        default:
            warn(`Unrecognized utag event: ${payload.event}`);
    }
}

/**
 * Poll for Tealium scripts being loaded
 */
export function* pollUtagSaga() {
    yield* takeEvery(POLL_UTAG, handlePollUtagSaga);
}

export function* handlePollUtagSaga({ payload }) {
    if (Date.now() < payload.endTime) {
        yield call(delay, 100);
        yield put(handleUtagEvent(payload.data, payload.event, payload.endTime));
    } else {
        error('handlePollUtagSaga: utag is undefined');
    }
}

export default [
    handleUtagEventSaga,
    pollUtagSaga,
    fireUtagSaga
];
